/**
 * flashFocusElement — calm scroll-and-highlight helper for the
 * Operational Continuity Convergence Batch V1 (Feb 28, 2026).
 *
 * Doctrine:
 *   • Calm, not theatrical. A short opacity ring fade. No bounce,
 *     no shake, no toast, no overlay.
 *   • Idempotent — safe to call when the element doesn't exist
 *     yet (no-op).
 *   • No external dependency; pure DOM + Tailwind classes that
 *     already exist in the project.
 */
export function flashFocusElement(elementId, { duration = 1800 } = {}) {
  if (!elementId) return;
  // Allow the next paint to commit before scrolling — many receivers
  // mount their row list in an async effect.
  requestAnimationFrame(() => {
    const el = document.getElementById(elementId);
    if (!el) return;
    try {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    } catch {
      // Older browsers without smooth-scroll support — silent fallback.
    }
    // Calm focus ring: amber-200 ring matches the Calm Guidance tile
    // family. Removed after `duration` ms so the page returns to its
    // normal visual state.
    el.classList.add(
      "ring-2",
      "ring-amber-300",
      "ring-offset-2",
      "transition",
      "duration-700",
    );
    window.setTimeout(() => {
      el.classList.remove(
        "ring-2",
        "ring-amber-300",
        "ring-offset-2",
      );
    }, duration);
  });
}

export default flashFocusElement;
